// Mark parameter/stream item default(cannot be delete) Or not, 'no' means default item
export const notDeleteKey = 'no';
// LOAD - action to trigger getting the data (NOP if already loaded, or loading)
// LOADING - after LOAD, in the process of loading
// LOADED - response returned
const DataSourceDetailConstants = {
    SET_ROUTE_CONTEXT: 'dataSourceDetail/SET_ROUTE_CONTEXT',
    SET_USER_CONTEXT: 'dataSourceDetail/SET_USER_CONTEXT',
    SET_PARTIAL_USER_CONTEXT: 'dataSourceDetail/SET_PARTIAL_USER_CONTEXT',
};
export default DataSourceDetailConstants;

//# sourceMappingURL=DataSourceDetailConstants.js.map
